<mat-menu #iconMenu="matMenu" [yPosition]="yPosition" [xPosition]="xPosition" class="small-icon-menu-panel">
  @for (action of displayActions; track action.action) {
    <button 
      mat-menu-item 
      [class]="'action-' + action.action"
      (click)="onActionClick(action, $event)">
      <mat-icon>{{ action.icon }}</mat-icon>
      
    </button>
  }
</mat-menu>